var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1185_5624)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15.25a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61 18.88c.07.11.18.32.2.56l.04.53.02.66c.01.31.29.62.7.62h2.91c.42 0 .71-.32.71-.62l.03-1.12c0-.27.13-.5.2-.62.08-.12.23-.32.46-.45l1.61-.88c.22-.13.48-.15.62-.15.15 0 .4.01.62.13l1.04.54c.34.18.78.05.96-.25l1.45-2.4c.17-.28.09-.67-.23-.85l-1.01-.59c-.23-.13-.38-.34-.45-.47-.07-.13-.19-.36-.19-.63v-1.77c0-.26.12-.5.19-.62.07-.13.22-.34.44-.47l1.01-.59c.31-.19.4-.57.23-.85l-1.45-2.4a.744.744 0 00-.96-.25l-1.04.54c-.22.12-.47.13-.62.13-.15 0-.4-.02-.63-.15l-1.61-.88c-.23-.12-.38-.32-.46-.45-.07-.12-.2-.35-.2-.62l-.03-1.12c-.02-.31-.31-.62-.71-.62h-2.91c-.41 0-.7.31-.71.62l-.03 1.13c-.01.27-.13.5-.21.62-.08.12-.23.33-.46.45l-1.6.88c-.22.11-.46.14-.61.14-.15 0-.4-.01-.63-.13l-1.04-.54c-.34-.18-.78-.05-.96.25l-1.45 2.4c-.17.28-.08.66.23.84l1.01.59c.22.13.36.33.44.46.07.12.19.36.19.63v1.77c0 .27-.12.51-.19.63-.07.13-.21.34-.44.47l-1.01.59c-.31.19-.4.57-.23.85l1.45 2.4c.18.29.61.43.96.25l1.04-.54c.23-.12.49-.13.63-.13.15.01.4.03.62.15l1.61.88c.22.12.37.33.45.45z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1185_5624"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    transform: "translate(2 2)",
    d: "M0 0h20v20H0z"
  })))));
}
SvgSettings.displayName = 'Settings';
export default SvgSettings;